import { getCookie } from "components/common/cookie";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// import { getToken } from "components/common/cookie";
import { useNavigate } from "react-router-dom";
import { UserCreators } from "redux/modules/user";

const Kakao = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let params = new URL(document.URL).searchParams;
  let code = params.get("code");

  React.useEffect(() => {
    dispatch(UserCreators.kakaoLogin(code))
      .unwrap()
      .then((res) => {
        if (res.accessToken === undefined) {
          navigate("/signup/agreement");
        } else if (res.accessToken) {
          // 유저정보 불러오기 api
          dispatch(UserCreators.getUserInfos());
          navigate("/", { state: "fromLogin" });
        }
      });
  }, []);

  return <></>;
};

export default Kakao;
